<template lang="pug">
f7-page#avex-coaches
  background
    retina-image.eyecatch(name="avex_coaches_top")

    p.about_online_lesson
      f7-link(@click="openAboutOnlineLesson") オンラインレッスンとは

    section.top
      p.section-title
        |レッスンを受けたい先生を選んで、
        br
        | 申し込みをしよう！
      p.description
        | ※申し込みは先着順の為、レッスン枠が埋まっている場合があります。

    avex-coach-list(@click="showDetail")

    pagination(
      @click="movePage"
      class="pagination"
      :currentPageNumber="currentPageNumber"
      :totalPageCount="totalPageCount"
      :hasPreviousPage="hasPreviousPage"
      :hasNextPage="hasNextPage")
</template>

<style lang="scss" scoped>
#avex-coaches {
  .eyecatch {
    width: 100%;
  }

  .about_online_lesson {
    margin: 0;
    text-align: center;
    a {
      @extend %body-text;
      text-decoration: underline;
    }
  }

  section.top {
    margin-top: 22px;
    margin-bottom: 34px;
    padding: 0 16px;

    p {
      margin: 0;
    }

    .section-title {
      @extend %headline-detail-text;
      margin-bottom: 8px;
    }

    .skip-login {
      margin-top: 16px;
      text-align: center;
    }
  }

  .background {
    padding-bottom: 46px;
    background-color: #16171a;
  }
}
</style>

<script>
import CoachesTop from '@/components/organisms/CoachesTop'
import AvexCoachList from '@/components/organisms/AvexCoachList'
import Pagination from '@/components/organisms/Pagination'
import Pager from '@/components/mixins/Pager'
import PageTitle from '@/components/mixins/PageTitle'

export default {
  title: 'スポともDance ✕ avex 講師一覧',
  components: {
    CoachesTop,
    AvexCoachList,
    Pagination,
  },
  mixins: [Pager, PageTitle],
  data() {
    return {
      displayType: 'with_logo',
    }
  },
  methods: {
    openAboutOnlineLesson() {
      open('https://dance-lp.spotomo.com/about_online_lesson.html', '_blank')
    },
    showDetail(coachId) {
      this.$f7router.navigate({
        name: 'PublicAvexCoachDetail',
        params: { id: coachId },
      })
    },
    setDisplayType(displayType) {
      this.displayType = displayType
    },
    didTapSkip() {
      this.postMessageToSwift('didTapSkip')
    },
  },
  created() {
    this.countPerPage = 30
    this.params.first = this.countPerPage
  },
}
</script>
